import * as styling from "./styling";

export const ESCAPE_KEY = 27;
export const TAB_KEY = 9;

export { styling };
